import { useLocation } from 'react-router-dom';
import { SEO_PAGE_KEYS, type SeoPageKey } from '@klaro7/shared-types';

import { usePublicSeoConfig } from '../hooks/useSeoConfig';
import { buildOrganizationJsonLd, buildWebSiteJsonLd } from '../lib/jsonLd';
import { withTitleSuffix } from '../lib/seoUtils';
import { JsonLd } from './JsonLd';
import { Seo } from './Seo';

/**
 * Applies the admin-configured meta tags for the current public route.
 * Mounted once in PlatformLayout; dynamic pages (consultant profile) render
 * their own <Seo> which wins because it mounts deeper in the tree.
 */
export function RouteSeo() {
  const { pathname } = useLocation();
  const { data: config } = usePublicSeoConfig();

  if (!config) return null;

  const key = (SEO_PAGE_KEYS as readonly string[]).includes(pathname)
    ? (pathname as SeoPageKey)
    : null;
  if (!key) return null;

  const page = config.pages[key] ?? {};
  const title = withTitleSuffix(page.title || config.global.defaultTitle, config);
  const origin = window.location.origin;

  return (
    <>
      <Seo
        title={title}
        description={page.description || config.global.defaultDescription}
        keywords={page.keywords?.length ? page.keywords : config.global.defaultKeywords}
        ogImage={page.ogImage || config.global.defaultOgImage}
        noindex={page.noindex}
      />
      {key === '/' && (
        <JsonLd
          data={[buildOrganizationJsonLd(config, origin), buildWebSiteJsonLd(config, origin)]}
        />
      )}
    </>
  );
}
